// @flow

export { BoletoPageContent } from './boleto';
export { EfectyPageContent } from './cash';
export { ArgentineCashPageContent } from './cash';
export { OxxoPageContent } from './oxxo';
export { SpeiPageContent } from './spei';
export { PixPageContent } from './pix';
export { NequiPageContent } from './nequi';
